(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/drawer/assets/javascripts/drawer.js') >= 0) return;  svs.modules.push('/components/lb-ui/drawer/assets/javascripts/drawer.js');

'use strict';

const _excluded = ["children", "className", "expandableAreaHeight", "onClickOverlay", "onSwipeClose", "onSwipeOpen", "isOpen", "isOverlayDisabled", "isSwipeEnabled", "direction", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const _React = React,
  useRef = _React.useRef;
const THRESHOLD_CLOSE_IF_OPEN = 0.1;
const THRESHOLD_OPEN_IF_CLOSED = 0.9;
const THRESHOLD_FAST_SWIPE = 0.04;
const useSwipe = _ref => {
  let expandableAreaHeight = _ref.expandableAreaHeight,
    isOpen = _ref.isOpen,
    onSwipeClose = _ref.onSwipeClose,
    onSwipeOpen = _ref.onSwipeOpen;
  const drawerElementRef = useRef(null);
  const swiping = useRef(false);
  const startClientY = useRef(0);
  const stopClientY = useRef(0);
  const windowHeight = useRef(0);
  const touchStartTime = useRef(0);
  const handleTouchStart = event => {
    if (event !== null && event !== void 0 && event.targetTouches[0]) {
      const clientY = event.targetTouches[0].clientY;
      startClientY.current = clientY;
      windowHeight.current = window.innerHeight;
      touchStartTime.current = performance.now();
    }
  };
  const handleTouchMove = event => {
    event === null || event === void 0 || event.stopPropagation();
    if (event !== null && event !== void 0 && event.targetTouches[0]) {
      const clientY = event.targetTouches[0].clientY;
      const isSwipingDown = clientY > startClientY.current;
      const isSwipingUp = clientY < startClientY.current;
      swiping.current = true;
      const swipingUpPosition = windowHeight.current - expandableAreaHeight - (startClientY.current - clientY);
      if (isOpen && isSwipingDown) {
        const position = Math.min(clientY - startClientY.current, windowHeight.current - expandableAreaHeight);
        requestAnimationFrame(() => {
          drawerElementRef.current.style.transform = "translate3d(0, ".concat(position, "px, 0)");
        });
      } else if (!isOpen && isSwipingUp && swipingUpPosition >= 0) {
        const position = Math.min(swipingUpPosition, windowHeight.current - expandableAreaHeight);
        requestAnimationFrame(() => {
          drawerElementRef.current.style.transform = "translate3d(0, ".concat(position, "px, 0)");
        });
      }
      stopClientY.current = clientY;
    }
  };
  const handleTouchEnd = () => {
    const currentDrawerPosition = drawerElementRef.current.getBoundingClientRect().y;
    if (swiping.current) {
      requestAnimationFrame(() => {
        drawerElementRef.current.style.transform = '';
      });
      swiping.current = false;
      const touchEndTime = performance.now();
      const swipeDuration = touchEndTime - touchStartTime.current;
      const swipeDistance = Math.abs(stopClientY.current - startClientY.current);
      const isSwipingFast = swipeDuration < 200 && swipeDistance >= windowHeight.current * THRESHOLD_FAST_SWIPE;
      const swipingUpPosition = windowHeight.current - expandableAreaHeight - (startClientY.current - stopClientY.current);
      const isSwipingUpFast = isSwipingFast && stopClientY.current < startClientY.current && swipingUpPosition >= 0;
      const isSwipingDownFast = isSwipingFast && stopClientY.current > startClientY.current;
      if (isOpen) {
        if (currentDrawerPosition >= windowHeight.current * THRESHOLD_CLOSE_IF_OPEN || isSwipingDownFast) {
          onSwipeClose();
        } else {
          onSwipeOpen();
        }
      } else if (currentDrawerPosition <= (windowHeight.current - expandableAreaHeight) * THRESHOLD_OPEN_IF_CLOSED || isSwipingUpFast) {
        onSwipeOpen();
      } else {
        onSwipeClose();
      }
      stopClientY.current = 0;
    }
  };
  return {
    drawerElementRef,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
    swiping: swiping.current
  };
};
const DirectionClasses = {
  bottom: 'drawer--is-bottom',
  left: 'drawer--is-left',
  right: 'drawer--is-right'
};
const Drawer = _ref2 => {
  let children = _ref2.children,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    _ref2$expandableAreaH = _ref2.expandableAreaHeight,
    expandableAreaHeight = _ref2$expandableAreaH === void 0 ? 0 : _ref2$expandableAreaH,
    _ref2$onClickOverlay = _ref2.onClickOverlay,
    onClickOverlay = _ref2$onClickOverlay === void 0 ? () => {} : _ref2$onClickOverlay,
    _ref2$onSwipeClose = _ref2.onSwipeClose,
    onSwipeClose = _ref2$onSwipeClose === void 0 ? () => {} : _ref2$onSwipeClose,
    _ref2$onSwipeOpen = _ref2.onSwipeOpen,
    onSwipeOpen = _ref2$onSwipeOpen === void 0 ? () => {} : _ref2$onSwipeOpen,
    _ref2$isOpen = _ref2.isOpen,
    isOpen = _ref2$isOpen === void 0 ? false : _ref2$isOpen,
    _ref2$isOverlayDisabl = _ref2.isOverlayDisabled,
    isOverlayDisabled = _ref2$isOverlayDisabl === void 0 ? false : _ref2$isOverlayDisabl,
    _ref2$isSwipeEnabled = _ref2.isSwipeEnabled,
    isSwipeEnabled = _ref2$isSwipeEnabled === void 0 ? false : _ref2$isSwipeEnabled,
    _ref2$direction = _ref2.direction,
    direction = _ref2$direction === void 0 ? 'left' : _ref2$direction,
    _ref2$style = _ref2.style,
    style = _ref2$style === void 0 ? {} : _ref2$style,
    props = _objectWithoutProperties(_ref2, _excluded);
  const _useSwipe = useSwipe({
      expandableAreaHeight,
      isOpen,
      onSwipeClose,
      onSwipeOpen
    }),
    drawerElementRef = _useSwipe.drawerElementRef,
    handleTouchStart = _useSwipe.handleTouchStart,
    handleTouchMove = _useSwipe.handleTouchMove,
    handleTouchEnd = _useSwipe.handleTouchEnd,
    swiping = _useSwipe.swiping;
  const overlayClassName = ['drawer-overlay'];
  const drawerClassName = ['lb-drawer', className, DirectionClasses[direction] || DirectionClasses.left];
  if (className) {
    drawerClassName.push(className);
    overlayClassName.push(className);
  }
  if (isOpen) {
    overlayClassName.push('drawer-overlay--is-open');
    drawerClassName.push('drawer--is-open');
  } else if (swiping) {
    overlayClassName.push('drawer-overlay--is-open');
  }
  return React.createElement(React.Fragment, null, !isOverlayDisabled && React.createElement("div", {
    className: overlayClassName.join(' '),
    "data-testid": "drawer-overlay",
    onClick: onClickOverlay
  }), React.createElement("div", _extends({
    className: drawerClassName.join(' '),
    "data-testid": "qa-drawer",
    onTouchEnd: isSwipeEnabled ? handleTouchEnd : undefined,
    onTouchMove: isSwipeEnabled ? handleTouchMove : undefined,
    onTouchStart: isSwipeEnabled ? handleTouchStart : undefined,
    ref: drawerElementRef,
    style: style
  }, props), children));
};
setGlobal('svs.components.lbUi.Drawer', Drawer);

 })(window);